import SHA256 from 'crypto-js/sha256';
const KEY = 'trusted-device';

export const useTrustedDevice = () => {
  const addTrustedDevice = (email: string, trustToken: string) => {
    const stored = localStorage.getItem(KEY);
    const data = stored ? JSON.parse(stored) : {};

    const emailHash = SHA256(email).toString();
    data[emailHash] = trustToken;

    localStorage.setItem(KEY, JSON.stringify(data));
  };

  const getTrustedTokens = (): Record<string, string> => {
    const stored = localStorage.getItem(KEY);
    return stored ? JSON.parse(stored) : {};
  };

  const deleteTrustedDevice = (email: string) => {
    const stored = localStorage.getItem(KEY);
    if (!stored) return;

    const data = JSON.parse(stored);
    const emailHash = SHA256(email).toString();
    const newData = Object.fromEntries(Object.entries(data).filter(([key]) => key !== emailHash));

    localStorage.setItem(KEY, JSON.stringify(newData));
  };

  const getTrustedTokenByCurrentEmail = (email: string): string | null => {
    const tokens = getTrustedTokens();

    const emailHash = SHA256(email).toString();
    return tokens[emailHash] || null;
  };

  return {
    addTrustedDevice,
    deleteTrustedDevice,
    getTrustedTokenByCurrentEmail,
  };
};
